import { Button, DatePicker, Form, Input, Select, Row, Col } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAvailableSlots, createBookingTask } from "../../../redux/rtk/features/crm/task/crmTaskSlice"
import { loadAllStaff } from "../../../redux/rtk/features/user/userSlice";
import { loadAllQuote } from "../../../redux/rtk/features/crm/quote/quoteSlice";

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export default function CreateQuoteForm({ onClose, createAs }) {
	// selector
	
	const { list: staffList, loading: staffLoading } = useSelector(
		(state) => state.users
	);
	const { loading: quoteLoading } = useSelector((state) => state.quote);
	const [loader, setLoader] = useState(false);
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [productList, setProductList] = useState([]);
	const [productId, setProductId] = useState("");
	const [userId, setUserId] = useState(0);
	const [maxPlayer, setMaxPlayer] = useState(0);
	const [date, setDate] = useState("");
	const [slotList, setSlotList] = useState([]);

	useEffect(() => {
		dispatch(loadAllStaff({ status: true }));
	}, [dispatch]);

	const onFinish = async (values) => {
		try {
			setLoader(true);
			const { bookingDate, ...rest } = values;
			const formData = {
				...rest,
				bookingDate: date,
				originalAmount: Number(values.finalAmount),
				finalAmount: Number(values.finalAmount),
				numberOfParticipants: Number(values.numberOfParticipants),
				slotTime: `${values.slotId}`,
				couponDiscount: 0,
				transactionCode: "N/A",
			};

			const resp = await dispatch(createBookingTask(formData));
			if (resp.payload.message === "success") {
				form.resetFields();
				dispatch(loadAllQuote());
				onClose();
			}
		} catch (error) {
			setLoader(false);
		}
		finally {
			setLoader(false);
		}
	};

	const onCancel = () => {
		form.resetFields();
		onClose();
	};

	const onFinishFailed = (errorInfo) => {
		console.log("Failed:", errorInfo);
		setLoader(false);
	};
	const { Option } = Select;

	const handleSelectedGames = (companyId) => {
		setUserId(companyId);
		staffList.map((item) => {
			if(item.id === companyId) {
	    	setMaxPlayer(item.maxPlayers)
				setProductList(item.product);
			}
		})
	}
const getAvailableSlotsList = async () => {
	const res = await dispatch(getAvailableSlots({date,productId,userId}))
	setSlotList(res?.payload?.data?.slots || [])

}
	useEffect(() => {
		if (date && productId && userId) {
		getAvailableSlotsList();
		}
	}, [date, productId, userId])


	const numberOfPlayers = Array.from({ length: Number(maxPlayer) || 0 }, (_, i) => i + 1);


	return (
		<div className='flex justify-center px-6 py-4'>
			<Form
				className='w-full'
				onFinish={onFinish}
				onFinishFailed={onFinishFailed}
				colon={false}
				layout='vertical'
				form={form}
				initialValues={
					createAs
						? {
							[createAs.name]: createAs.value,
						}
						: {}
				}>
				<div className='flex justify-center gap-5'>
					<div className='w-1/2'>
						<Form.Item label='Franchise' name='franchiseId' 
						tooltip='This is a required field'
							rules={[
								{ required: true, message: "Please select franchise." },
							]}>
							<Select
								style={{ width: "100%" }}
								loading={staffLoading}
								allowClear
								showSearch
								placeholder='Select Franchise Name'
								disabled={!!(createAs?.name === "companyId")}
								onChange={(e) => handleSelectedGames(e)}
								>
								{staffList?.map((item) => (
									<Select.Option key={item.id} value={item.id}>
										{item.franchiseName}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					</div>
					<div className='w-1/2'>
						<Form.Item
							label='Game Room'
							name={"gameId"}
							tooltip='This is a required field'
							rules={[
								{ required: true, message: "Please select game." },
							]}>
							<Select
								style={{ width: "100%" }}
								loading={staffLoading}
								allowClear
								showSearch
								placeholder='Select Game'
								onChange={(e) => setProductId(e)}
							>
								{productList?.map((item) => (
									<Select.Option key={item.product.id} value={item.product.id}>
										{item.product.gameName} {/* Adjust based on your data structure */}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					</div>
				</div>
				<div className="border-t border-[#ccc]">
					<h2 className="font-bold text-2xl mt-3 mb-2">Fill Booking Details</h2>
					<Row gutter={16}>
						<Col xs={24} md={12}>
							<Form.Item label="Choose Booking Date" name="bookingDate" required
								tooltip='This is a required field'
								rules={[
									{ required: true, message: "Please select date." },
								]}>
								<DatePicker
									format="DD-MM-YYYY"
									style={{ width: "100%" }}
									onChange={(date, dateString) => setDate(date ? date.format('MM-DD-YYYY') : '')}
									disabledDate={(current) => {
										// Disable today and all dates before tomorrow
										return current && current <= dayjs().endOf('day');
									}}
								/>
							</Form.Item>
						</Col>
						<Col xs={24} md={12}>
							<Form.Item label="Participant Name"  name="name" required
							 tooltip='This is a required field'
							 rules={[
								 { required: true, message: "Please select participant name." },
							 ]}>
								<Input placeholder="Enter Name" />
							</Form.Item>
						</Col>
						<Col xs={24} md={12}>
							<Form.Item label="Select Participants" name="numberOfParticipants" required
								tooltip='This is a required field'
								rules={[
									{ required: true, message: "Please select participants." },
								]}>
								<Select placeholder="Select Participants">
									{numberOfPlayers.map((option) => (
										<Option key={option} value={option.toString()}>
											{option}
										</Option>
									))}
								</Select>
							</Form.Item>
						</Col>
						<Col xs={24} md={12}>
							<Form.Item label="Participant Email" name="email" required
								tooltip='This is a required field'
								rules={[
									{ required: true, message: "Please enter participant Email." },
								]}>
								<Input placeholder="Enter Email" />
							</Form.Item>
						</Col>
						<Col xs={24} md={12}>
							<Form.Item label="Select Slot" name="slotId" required tooltip='This is a required field'
								rules={[
									{ required: true, message: "Please select slot." },
								]}>
								<Select placeholder="Please Select Slot">
									{slotList?.map((item) => (
									<Select.Option key={item.id} value={item.id}>
										{item.slotName} {/* Adjust based on your data structure */}
									</Select.Option>
								))}
								</Select>
							</Form.Item>
						</Col>
						<Col xs={24} md={12}>
							<Form.Item label="Participant Contact" name="contact" required 
							tooltip='This is a required field'
							rules={[
								{ required: true, message: "Please enter contact number." },
								]}>
								<Input placeholder="Enter Contact here" />
							</Form.Item>
						</Col>
						<Col xs={24} md={12}>
							<Form.Item label="Amount" name="finalAmount" required
							tooltip='This is a required field'
							rules={[
								{ required: true, message: "Please enter amount." },
								]}>
								<Input placeholder="Enter Slot cost" />
							</Form.Item>
						</Col>
						<Col xs={24} md={12}>
							<Form.Item label="Choose Payment Type" name="paymentGateway" required
							tooltip='This is a required field'
							rules={[
								{ required: true, message: "Please select payment type." },
								]}>
								<Select placeholder="Please Select Payment Type">
									<Option value="Cash">Cash</Option>
								</Select>
							</Form.Item>
						</Col>
					</Row>
				</div>
				<div className='flex justify-center'>
					<div className='w-full'>
						<Form.Item label=''>
							<div className='flex items-center gap-2'>
								<Button
									size={"large"}
									htmlType='submit'
									loading={loader}
									className="btn-primary hover:border-[#E5383B]"
								>
									Create
								</Button>
								<Button
									size={"large"}
									htmlType='submit'
									type='danger'
									onClick={onCancel}
									className="btn-tertiary"
									>
									Cancel
								</Button>
							</div>
						</Form.Item>
					</div>
				</div>
			</Form>
		</div>
	);
}
